import {type ThemeColorPath} from 'platform/foundation';
import {match, Pattern} from 'ts-pattern';

export type PhotoCheckerVariant = 'pass' | 'caution' | 'fail' | 'missing';

const PHOTO_CHECKER_SCORE_PASS_THRESHOLD = 80;
const PHOTO_CHECKER_SCORE_CAUTION_THRESHOLD = 60;

export function getPhotoCheckerColorVariant(score?: number): PhotoCheckerVariant {
  return match<number | undefined, PhotoCheckerVariant>(score)
    .with(Pattern.nullish, () => 'fail')
    .when(
      (s) => s < PHOTO_CHECKER_SCORE_CAUTION_THRESHOLD,
      () => 'fail'
    )
    .when(
      (s) => s < PHOTO_CHECKER_SCORE_PASS_THRESHOLD,
      () => 'caution'
    )
    .otherwise(() => 'pass');
}

export function getPhotoCheckerScoreBadgeColor(variant: PhotoCheckerVariant): ThemeColorPath {
  return match<PhotoCheckerVariant, ThemeColorPath>(variant)
    .with('pass', () => 'palettes.green.50.100')
    .with('caution', () => 'palettes.orange.70.100')
    .with('fail', () => 'severity.danger')
    .with('missing', () => 'severity.danger')
    .exhaustive();
}
